import React, { Component } from 'react';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
  blue500,
  blue700,
  blueGrey100,
  blueGrey500,
  darkBlack,
  grey300,
  lightBlack,
  purpleA200,
  lightGreen900,
  lime500,
  deepOrange500,
  lightGreenA400,
  lightGreen500,
  white
} from 'material-ui/styles/colors';
import Avatar from 'material-ui/Avatar';
import spacing from 'material-ui/styles/spacing'
import { fade } from 'material-ui/utils/colorManipulator'
import injectTapEventPlugin from 'react-tap-event-plugin';
import FontIcon from 'material-ui/FontIcon';
import GoogleLogin from 'react-google-login';
import { Link, Redirect } from 'react-router-dom';
import AppBar from 'material-ui/AppBar';



const styles = {
  iconStyles: {
    marginRight: 24,
  }
};

const muiTheme = getMuiTheme({
  spacing: {
    iconSize: 24,
    desktopGutter: 24,
    desktopGutterMore: 32,
    desktopGutterLess: 16,
    desktopGutterMini: 8,
    desktopKeylineIncrement: 64,
    desktopDropDownMenuItemHeight: 32,
    desktopDropDownMenuFontSize: 15,
    desktopLeftNavMenuItemHeight: 48,
    desktopSubheaderHeight: 48,
    desktopToolbarHeight: 56,
  },
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: blue500,
    primary2Color: blue700,
    primary3Color: lightBlack,
    accent1Color: purpleA200,
    accent2Color: blueGrey100,
    accent3Color: blueGrey500,
    textColor: darkBlack,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: blue500,
    backCanvas: {
      viewportBackgroundColor: white,
      navDrawerBoxShadow: true
    },
  },
  avatar: {
    borderColor: white,
  },
});

class Login extends Component {
    path = "/home";
  constructor(props) {    
    super(props);       
    if(props.location && props.location.state && props.location.state.path)
    sessionStorage.setItem("path",props.location.state.path);
    var isLoggedIn = false; 
    var time = parseInt(localStorage.getItem("auth_expiry"));    
    if(!isNaN(time)){    
        if(Math.abs(time - Date.now())/36e5 > 1){          
          localStorage.clear(); 
        }
      else{
        isLoggedIn = true;
      }
      
    }
    this.state = { open: false, showProgressIndicator: false, isLoggedIn : isLoggedIn};    
    this.setState({user : localStorage.getItem("user")});
    
  }
  responseGoogle = (response) => {    
    if(response.profileObj && response.tokenObj){      
      localStorage.setItem("bs_authtoken",response.tokenObj.access_token);
      localStorage.setItem("auth_expiry",Date.now());
      localStorage.setItem("user",response.profileObj.name);
      this.setState({isLoggedIn : true, user : response.profileObj.name});
      console.log(sessionStorage.getItem("path"));
    }
    
  }

  render() {
    let { builds, showProgressIndicator, config } = this.state;    
      let styles = {      
        button : {
          background: "#2196F3",
          padding: "10px",          
          color: "#ffffff",
          align : "center",
          fontweight : "400",
          width : "200"                
        },
        background: "#2196F3"              
      }    
    let user = localStorage.getItem("user");
    
    if(!this.state.isLoggedIn){
      return(
        <MuiThemeProvider>
          <div>
          <AppBar
             title="Build Dashboard" style = {styles}/>                  
              <GoogleLogin
                clientId="439747102374-svc9c6g06tujip1ksmctc8j0rt47q6e1.apps.googleusercontent.com"
                buttonText="   Login   "
                hostedDomain = "logitech.com"
                onSuccess={this.responseGoogle}
                onFailure={this.responseGoogle}
                buttonText = "Sign In"
                style = {styles.button}
              />
         </div>
         </MuiThemeProvider>
      );      
    }
    else{
      return (                    
         <Redirect to={this.path}/>
      );
    }    
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login.js